module.exports = __webpack_public_path__ + "static/Auto-Share-9-e1407759106824-3ae869c09a2c2f72df382b67655d5b70.jpg";